import { render } from "./Config.vue?vue&type=template&id=264eecfc&scoped=true"
import script from "./Config.vue?vue&type=script&lang=js"
export * from "./Config.vue?vue&type=script&lang=js"

import "./Config.vue?vue&type=style&index=0&id=264eecfc&scoped=true&lang=css"

import exportComponent from "/Users/onisiforosgeorgiou/WebstormProjects/AgencyNow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-264eecfc"]])

export default __exports__